export default function Wheelchair({ className = "" }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 48 48"
      className={className}>
      <path d="M46.7 36.8c-.5-.7-1.5-.8-2.1-.3l-3.5 2.8-7.7-9c-.3-.3-.7-.5-1.1-.5H21.9c-1.6 0-2.8-1.3-2.8-2.8v-3.4H29c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-9.9v-6.2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V27c0 3.2 2.6 5.8 5.8 5.8h9.6l8.2 9.6c.3.3.7.5 1.1.5.3 0 .6-.1.9-.3l4.6-3.6c.8-.6.9-1.5.4-2.2z" />
      <path d="M30.9 39c-.7-.5-1.6-.3-2.1.3-2.6 3.6-6.7 5.7-11.1 5.7C10.1 45 4 38.9 4 31.3c0-5.3 3-10 7.7-12.3.7-.4 1.1-1.3.7-2-.4-.7-1.3-1.1-2-.7C4.7 19.1 1 25 1 31.3 1 40.5 8.5 48 17.7 48c5.3 0 10.4-2.6 13.5-6.9.5-.7.4-1.6-.3-2.1zM17.6 10.7c2.9 0 5.3-2.4 5.3-5.3S20.5 0 17.6 0s-5.3 2.4-5.3 5.3 2.4 5.4 5.3 5.4zm0-7.7c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3z" />
    </svg>
  )
}
